import { colorVariants, Description } from '@casavo/base-ui'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'

import { useDevice } from '@/context/Device'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { handleClickCallAgency } from '@/utils/tracking/eventsHandlers'

import CasavoAssistant from '../Icon/CasavoAssistant'

import { casavoAssistantPhoneWrapper } from './styles.css'

type Props = {
  className?: string
  isDesktop?: boolean
  number: string
}

const CasavoAssistantPhone: React.FC<Props> = ({ className, isDesktop, number }) => {
  const { t } = useTranslation()
  const device = useDevice()
  const iconSize = 34

  return (
    <div className={cn(className, casavoAssistantPhoneWrapper)} data-testid="casavo-assistant-phone">
      <CasavoAssistant
        className={cn(
          colorVariants['orange600'],
          sprinkles({
            marginRight: 's-m',
          })
        )}
        height={iconSize}
        width={iconSize}
      />
      <div className={!isDesktop && sprinkles({ alignItems: 'center', display: 'flex', flex: 1 })}>
        <Description>{t('contact-form:casavo.assistant')}</Description>
        <span className={sprinkles({ marginLeft: 'auto' })}>
          {device === 'mobile' ? (
            <a
              href={`tel:${number}`}
              onClick={() => {
                handleClickCallAgency('ListingDetail', 'Call')
              }}
            >
              <Description>{number}</Description>
            </a>
          ) : (
            <Description>{number}</Description>
          )}
        </span>
      </div>
    </div>
  )
}

export default CasavoAssistantPhone
